export function warn(location, message) {
    console.error(`[vueuc/${location}]: ${message}`);
}
